import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Scale, Building, FileText, Globe, AlertCircle } from 'lucide-react';

const Legal = () => {
  const { i18n } = useTranslation();

  const content = {
    fr: {
      title: "Mentions Légales",
      subtitle: "Informations légales et réglementaires",
      lastUpdate: "Dernière mise à jour : Décembre 2025",
      sections: [
        {
          icon: Building,
          title: "1. Éditeur du Site",
          content: null,
          info: [
            { label: "Raison sociale", value: "EDENLIFE International" },
            { label: "Forme juridique", value: "Organisation à but non lucratif" },
            { label: "Siège social", value: "6205, Blvd. des Grandes Prairies, Suite 215-216, Saint-Léonard, QC H1P 1A2, Canada" },
            { label: "Téléphone", value: "1 866-722-7007" },
            { label: "Email", value: "contact@marathon-edenlifeintl.org" }
          ]
        },
        {
          icon: Globe,
          title: "2. Hébergement",
          content: "Le site Marathon de l'Avenir EDENLIFE 2026 est hébergé sur des serveurs sécurisés conformes aux normes internationales de protection des données. L'infrastructure technique garantit la disponibilité, la sécurité et la confidentialité des données des utilisateurs.",
          info: null
        },
        {
          icon: FileText,
          title: "3. Propriété Intellectuelle",
          content: "L'ensemble du contenu présent sur ce site (textes, images, logos, design, code source, base de données) est la propriété exclusive d'EDENLIFE International ou de ses partenaires, et est protégé par les lois nationales et internationales relatives à la propriété intellectuelle.\n\nLe logo EDENLIFE, le nom « Marathon de l'Avenir EDENLIFE 2026 » et tous les éléments graphiques associés sont des marques déposées. Toute reproduction, représentation, modification, publication, adaptation ou exploitation non autorisée est strictement interdite et peut faire l'objet de poursuites judiciaires.",
          info: null
        },
        {
          icon: Scale,
          title: "4. Nature du Marathon et Règlement",
          content: "Le Marathon de l'Avenir EDENLIFE 2026 est une initiative de collecte de fonds organisée par EDENLIFE International. L'achat de billets constitue une participation à cette levée de fonds avec la possibilité de gagner des prix lors du tirage au sort final.\n\n• Période du marathon : Du 1er mars 2026 au 31 décembre 2026\n• Prix des billets : 50 USD l'unité ou 3 billets pour 100 USD\n• Tirage au sort : Effectué de manière aléatoire et transparente en décembre 2026\n• Résultats : Définitifs et ne peuvent être contestés\n• Les gagnants seront contactés par email et téléphone dans les 7 jours suivant le tirage",
          info: null
        },
        {
          icon: null,
          title: "5. Responsabilité",
          content: "EDENLIFE International s'efforce de fournir des informations exactes et à jour sur ce site. Toutefois, nous ne pouvons garantir l'exactitude, la complétude ou l'actualité permanente des informations diffusées.\n\nL'utilisateur est seul responsable de l'utilisation qu'il fait des informations présentes sur ce site. EDENLIFE International ne saurait être tenu responsable des dommages directs ou indirects résultant de l'accès au site ou de l'utilisation des informations qu'il contient.",
          info: null
        },
        {
          icon: null,
          title: "6. Liens Externes",
          content: "Ce site peut contenir des liens vers des sites tiers (réseaux sociaux, partenaires de paiement, etc.). EDENLIFE International n'exerce aucun contrôle sur le contenu de ces sites et décline toute responsabilité quant à leur contenu, leurs pratiques de confidentialité ou à l'utilisation qui pourrait en être faite.",
          info: null
        },
        {
          icon: null,
          title: "7. Droit Applicable et Juridiction",
          content: "Les présentes mentions légales sont régies par le droit canadien et les lois de la province du Québec. Tout litige relatif à l'utilisation de ce site, à l'interprétation ou à l'exécution des présentes conditions sera soumis à la compétence exclusive des tribunaux de Montréal, Québec, Canada.",
          info: null
        },
        {
          icon: null,
          title: "8. Modification des Mentions Légales",
          content: "EDENLIFE International se réserve le droit de modifier ces mentions légales à tout moment et sans préavis. Les modifications entrent en vigueur dès leur publication sur le site. Il est conseillé aux utilisateurs de consulter régulièrement cette page pour prendre connaissance des éventuelles mises à jour.",
          info: null
        }
      ],
      contactNote: "Pour toute question concernant ces mentions légales, veuillez nous contacter à : contact@marathon-edenlifeintl.org ou par téléphone au 1 866-722-7007."
    },
    en: {
      title: "Legal Notice",
      subtitle: "Legal and regulatory information",
      lastUpdate: "Last updated: December 2025",
      sections: [
        {
          icon: Building,
          title: "1. Site Publisher",
          content: null,
          info: [
            { label: "Company Name", value: "EDENLIFE International" },
            { label: "Legal Form", value: "Non-profit Organization" },
            { label: "Headquarters", value: "6205 Blvd. des Grandes Prairies, Suite 215-216, Saint-Leonard, QC H1P 1A2, Canada" },
            { label: "Phone", value: "1 866-722-7007" },
            { label: "Email", value: "contact@marathon-edenlifeintl.org" }
          ]
        },
        {
          icon: Globe,
          title: "2. Hosting",
          content: "The EDENLIFE Marathon 2026 website is hosted on secure servers compliant with international data protection standards. The technical infrastructure ensures the availability, security and confidentiality of user data.",
          info: null
        },
        {
          icon: FileText,
          title: "3. Intellectual Property",
          content: "All content on this site (texts, images, logos, design, source code, database) is the exclusive property of EDENLIFE International or its partners, and is protected by national and international intellectual property laws.\n\nThe EDENLIFE logo, the name 'EDENLIFE Marathon 2026' and all associated graphic elements are registered trademarks. Any unauthorized reproduction, representation, modification, publication, adaptation or exploitation is strictly prohibited and may result in legal action.",
          info: null
        },
        {
          icon: Scale,
          title: "4. Nature of the Marathon and Rules",
          content: "The EDENLIFE Marathon 2026 is a fundraising initiative organized by EDENLIFE International. Purchasing tickets constitutes participation in this fundraiser with the possibility of winning prizes in the final draw.\n\n• Marathon period: From March 1, 2026 to December 31, 2026\n• Ticket prices: $50 USD each or 3 tickets for $100 USD\n• Draw: Conducted randomly and transparently in December 2026\n• Results: Final and cannot be contested\n• Winners will be contacted by email and phone within 7 days of the draw",
          info: null
        },
        {
          icon: null,
          title: "5. Liability",
          content: "EDENLIFE International strives to provide accurate and up-to-date information on this site. However, we cannot guarantee the accuracy, completeness or permanent timeliness of the information provided.\n\nThe user is solely responsible for how they use the information on this site. EDENLIFE International cannot be held liable for any direct or indirect damages resulting from access to the site or use of the information it contains.",
          info: null
        },
        {
          icon: null,
          title: "6. External Links",
          content: "This site may contain links to third-party sites (social networks, payment partners, etc.). EDENLIFE International has no control over the content of these sites and disclaims all responsibility for their content, privacy practices or any use that may be made of them.",
          info: null
        },
        {
          icon: null,
          title: "7. Applicable Law and Jurisdiction",
          content: "These legal notices are governed by Canadian law and the laws of the Province of Quebec. Any dispute relating to the use of this site, the interpretation or execution of these conditions shall be subject to the exclusive jurisdiction of the courts of Montreal, Quebec, Canada.",
          info: null
        },
        {
          icon: null,
          title: "8. Modification of Legal Notice",
          content: "EDENLIFE International reserves the right to modify this legal notice at any time without notice. Changes take effect upon publication on the site. Users are advised to consult this page regularly to be aware of any updates.",
          info: null
        }
      ],
      contactNote: "For any questions regarding this legal notice, please contact us at: contact@marathon-edenlifeintl.org or by phone at 1 866-722-7007."
    },
    ht: {
      title: "Mansyon Legal",
      subtitle: "Enfòmasyon legal ak regilasyon",
      lastUpdate: "Dènye mizajou: Desanm 2025",
      sections: [
        {
          icon: Building,
          title: "1. Editè Sit la",
          content: null,
          info: [
            { label: "Non Konpayi", value: "EDENLIFE International" },
            { label: "Fòm Legal", value: "Òganizasyon san bi likratif" },
            { label: "Syèj Sosyal", value: "6205 Blvd. des Grandes Prairies, Suite 215-216, Saint-Léonard, QC H1P 1A2, Kanada" },
            { label: "Telefòn", value: "1 866-722-7007" },
            { label: "Imel", value: "contact@marathon-edenlifeintl.org" }
          ]
        },
        {
          icon: Globe,
          title: "2. Ebèjman",
          content: "Sit Maraton EDENLIFE 2026 la ebèje sou sèvè sekirize ki konfòm ak estanda entènasyonal pwoteksyon done yo. Enfrastrikti teknik la garanti disponibilite, sekirite ak konfidansyalite done itilizatè yo.",
          info: null
        },
        {
          icon: FileText,
          title: "3. Pwopriyete Entelektyèl",
          content: "Tout kontni sou sit sa a (tèks, imaj, logo, design, kòd sous, baz done) se pwopriyete eksklizif EDENLIFE International oswa patnè li yo, epi pwoteje pa lwa nasyonal ak entènasyonal konsènan pwopriyete entelektyèl.\n\nLogo EDENLIFE, non \"Maraton EDENLIFE 2026\" ak tout eleman grafik asosye yo se mak depoze. Nenpòt repwodiksyon, reprezantasyon, modifikasyon, piblikasyon, adaptasyon oswa eksplwatasyon ki pa otorize entèdi epi ka lakòz aksyon legal.",
          info: null
        },
        {
          icon: Scale,
          title: "4. Nati Maraton an ak Règleman",
          content: "Maraton EDENLIFE 2026 se yon inisyativ koleksyon fon òganize pa EDENLIFE International. Achte tikè konstitye yon patisipasyon nan koleksyon fon sa a ak posiblite pou genyen pri nan tiraj final la.\n\n• Peryòd maraton: Soti 1ye mas 2026 rive 31 desanm 2026\n• Pri tikè: 50 USD chak oswa 3 tikè pou 100 USD\n• Tiraj: Fèt o aza ak transparans an desanm 2026\n• Rezilta: Final epi pa ka konteste\n• Gayan yo ap kontakte pa imel ak telefòn nan 7 jou apre tiraj la",
          info: null
        },
        {
          icon: null,
          title: "5. Responsablite",
          content: "EDENLIFE International eseye bay enfòmasyon egzak ak ajou sou sit sa a. Sepandan, nou pa ka garanti egzaktitid, konplètman oswa aktualite pèmanan enfòmasyon yo.\n\nItilizatè a sèl responsab itilizasyon li fè enfòmasyon ki sou sit sa a. EDENLIFE International pa ka responsab pou domaj dirèk oswa endirèk ki rezilte nan aksè a sit la oswa itilizasyon enfòmasyon li genyen.",
          info: null
        },
        {
          icon: null,
          title: "6. Lyen Ekstèn",
          content: "Sit sa a ka genyen lyen ki mennen nan sit twazyèm pati (rezo sosyal, patnè peman, elatriye). EDENLIFE International pa gen okenn kontwòl sou kontni sit sa yo epi refize tout responsablite pou kontni yo, pratik konfidansyalite yo oswa nenpòt itilizasyon ki ta ka fèt.",
          info: null
        },
        {
          icon: null,
          title: "7. Lwa Aplikab ak Jiridiksyon",
          content: "Mansyon legal sa yo gouvène pa lwa Kanadyen ak lwa Pwovens Kebèk. Nenpòt konfli konsènan itilizasyon sit sa a, entèpretasyon oswa ekzekisyon kondisyon sa yo ap soumèt a jiridiksyon eksklizif tribinal Montreal, Kebèk, Kanada.",
          info: null
        },
        {
          icon: null,
          title: "8. Modifikasyon Mansyon Legal yo",
          content: "EDENLIFE International rezève dwa pou modifye mansyon legal sa yo nenpòt ki lè san avi. Chanjman yo antre an vigè depi yo pibliye sou sit la. Nou konseye itilizatè yo pou konsilte paj sa a regilyèman pou konnen nenpòt mizajou."
        }
      ],
      contactNote: "Pou nenpòt kesyon konsènan mansyon legal sa yo, tanpri kontakte nou nan: contact@marathon-edenlifeintl.org oswa pa telefòn nan 1 866-722-7007."
    },
    es: {
      title: "Aviso Legal",
      subtitle: "Información legal y reglamentaria",
      lastUpdate: "Última actualización: Diciembre 2025",
      sections: [
        {
          icon: Building,
          title: "1. Editor del Sitio",
          content: null,
          info: [
            { label: "Razón Social", value: "EDENLIFE International" },
            { label: "Forma Jurídica", value: "Organización sin fines de lucro" },
            { label: "Sede Social", value: "6205, Blvd. des Grandes Prairies, Suite 215-216, Saint-Léonard, QC H1P 1A2, Canadá" },
            { label: "Teléfono", value: "1 866-722-7007" },
            { label: "Correo", value: "contact@marathon-edenlifeintl.org" }
          ]
        },
        {
          icon: Globe,
          title: "2. Alojamiento",
          content: "El sitio Maratón EDENLIFE 2026 está alojado en servidores seguros que cumplen con los estándares internacionales de protección de datos. La infraestructura técnica garantiza la disponibilidad, seguridad y confidencialidad de los datos de los usuarios.",
          info: null
        },
        {
          icon: FileText,
          title: "3. Propiedad Intelectual",
          content: "Todo el contenido presente en este sitio (textos, imágenes, logos, diseño, código fuente, base de datos) es propiedad exclusiva de EDENLIFE International o de sus socios, y está protegido por las leyes nacionales e internacionales relativas a la propiedad intelectual.\n\nEl logo EDENLIFE, el nombre «Maratón EDENLIFE 2026» y todos los elementos gráficos asociados son marcas registradas. Cualquier reproducción, representación, modificación, publicación, adaptación o explotación no autorizada está estrictamente prohibida.",
          info: null
        },
        {
          icon: Scale,
          title: "4. Naturaleza del Maratón y Reglamento",
          content: "El Maratón EDENLIFE 2026 es una iniciativa de recaudación de fondos organizada por EDENLIFE International. La compra de boletos constituye una participación en esta recaudación con la posibilidad de ganar premios en el sorteo final.\n\n• Período del maratón: Del 1 de marzo de 2026 al 31 de diciembre de 2026\n• Precio de los boletos: 50 USD por unidad o 3 boletos por 100 USD\n• Sorteo: Realizado de manera aleatoria y transparente en diciembre de 2026\n• Resultados: Definitivos y no pueden ser impugnados\n• Los ganadores serán contactados por correo y teléfono dentro de los 7 días siguientes al sorteo",
          info: null
        },
        {
          icon: null,
          title: "5. Responsabilidad",
          content: "EDENLIFE International se esfuerza por proporcionar información exacta y actualizada en este sitio. Sin embargo, no podemos garantizar la exactitud, completitud o actualidad permanente de la información difundida.",
          info: null
        },
        {
          icon: null,
          title: "6. Enlaces Externos",
          content: "Este sitio puede contener enlaces a sitios de terceros (redes sociales, socios de pago, etc.). EDENLIFE International no ejerce ningún control sobre el contenido de estos sitios y declina toda responsabilidad en cuanto a su contenido.",
          info: null
        },
        {
          icon: null,
          title: "7. Ley Aplicable y Jurisdicción",
          content: "Las presentes menciones legales se rigen por la ley canadiense y las leyes de la provincia de Quebec. Cualquier disputa relativa a la utilización de este sitio será sometida a la competencia exclusiva de los tribunales de Montreal, Quebec, Canadá.",
          info: null
        },
        {
          icon: null,
          title: "8. Modificación de las Menciones Legales",
          content: "EDENLIFE International se reserva el derecho de modificar estas menciones legales en cualquier momento y sin previo aviso. Las modificaciones entran en vigor desde su publicación en el sitio."
        }
      ],
      contactNote: "Para cualquier pregunta sobre estas menciones legales, contáctenos en: contact@marathon-edenlifeintl.org o por teléfono al 1 866-722-7007."
    },
    pt: {
      title: "Aviso Legal",
      subtitle: "Informações legais e regulamentares",
      lastUpdate: "Última atualização: Dezembro 2025",
      sections: [
        {
          icon: Building,
          title: "1. Editor do Site",
          content: null,
          info: [
            { label: "Razão Social", value: "EDENLIFE International" },
            { label: "Forma Jurídica", value: "Organização sem fins lucrativos" },
            { label: "Sede Social", value: "6205, Blvd. des Grandes Prairies, Suite 215-216, Saint-Léonard, QC H1P 1A2, Canadá" },
            { label: "Telefone", value: "1 866-722-7007" },
            { label: "Email", value: "contact@marathon-edenlifeintl.org" }
          ]
        },
        {
          icon: Globe,
          title: "2. Hospedagem",
          content: "O site Maratona EDENLIFE 2026 está hospedado em servidores seguros em conformidade com os padrões internacionais de proteção de dados. A infraestrutura técnica garante a disponibilidade, segurança e confidencialidade dos dados dos usuários.",
          info: null
        },
        {
          icon: FileText,
          title: "3. Propriedade Intelectual",
          content: "Todo o conteúdo presente neste site (textos, imagens, logos, design, código fonte, banco de dados) é propriedade exclusiva da EDENLIFE International ou de seus parceiros, e é protegido pelas leis nacionais e internacionais relativas à propriedade intelectual.\n\nO logo EDENLIFE, o nome «Maratona EDENLIFE 2026» e todos os elementos gráficos associados são marcas registradas. Qualquer reprodução, representação, modificação, publicação, adaptação ou exploração não autorizada é estritamente proibida.",
          info: null
        },
        {
          icon: Scale,
          title: "4. Natureza da Maratona e Regulamento",
          content: "A Maratona EDENLIFE 2026 é uma iniciativa de arrecadação de fundos organizada pela EDENLIFE International. A compra de bilhetes constitui uma participação nesta arrecadação com a possibilidade de ganhar prêmios no sorteio final.\n\n• Período da maratona: De 1º de março de 2026 a 31 de dezembro de 2026\n• Preço dos bilhetes: 50 USD por unidade ou 3 bilhetes por 100 USD\n• Sorteio: Realizado de forma aleatória e transparente em dezembro de 2026\n• Resultados: Definitivos e não podem ser contestados\n• Os ganhadores serão contatados por email e telefone dentro de 7 dias após o sorteio",
          info: null
        },
        {
          icon: null,
          title: "5. Responsabilidade",
          content: "A EDENLIFE International esforça-se para fornecer informações exatas e atualizadas neste site. No entanto, não podemos garantir a exatidão, completude ou atualidade permanente das informações divulgadas.",
          info: null
        },
        {
          icon: null,
          title: "6. Links Externos",
          content: "Este site pode conter links para sites de terceiros (redes sociais, parceiros de pagamento, etc.). A EDENLIFE International não exerce nenhum controle sobre o conteúdo desses sites e se isenta de toda responsabilidade quanto ao seu conteúdo.",
          info: null
        },
        {
          icon: null,
          title: "7. Lei Aplicável e Jurisdição",
          content: "As presentes menções legais são regidas pela lei canadense e pelas leis da província de Quebec. Qualquer disputa relativa à utilização deste site será submetida à competência exclusiva dos tribunais de Montreal, Quebec, Canadá.",
          info: null
        },
        {
          icon: null,
          title: "8. Modificação das Menções Legais",
          content: "A EDENLIFE International reserva-se o direito de modificar estas menções legais a qualquer momento e sem aviso prévio. As modificações entram em vigor a partir de sua publicação no site."
        }
      ],
      contactNote: "Para qualquer pergunta sobre estas menções legais, entre em contato conosco em: contact@marathon-edenlifeintl.org ou por telefone no 1 866-722-7007."
    }
  };

  const t = content[i18n.language] || content.fr;

  return (
    <div className="min-h-screen pt-24 px-6 pb-12" style={{ background: 'linear-gradient(135deg, #F4F1DE 0%, #E8E3D3 100%)' }}>
      <div className="max-w-4xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <div className="text-center mb-12">
            <Scale className="w-20 h-20 text-primary mx-auto mb-4" />
            <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              {t.title}
            </h1>
            <p className="text-gray-600">{t.subtitle}</p>
            <p className="text-sm text-gray-500 mt-2">{t.lastUpdate}</p>
          </div>

          <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-8 md:p-12 space-y-8">
            {t.sections.map((section, index) => {
              const Icon = section.icon;
              return (
                <section key={index}>
                  <div className="flex items-center space-x-3 mb-4">
                    {Icon && <Icon className="w-8 h-8 text-primary" />}
                    <h2 className="text-xl md:text-2xl font-bold text-primary">{section.title}</h2>
                  </div>
                  
                  {section.info && (
                    <div className="bg-primary/5 rounded-xl p-6 space-y-3">
                      {section.info.map((item, i) => (
                        <p key={i} className="text-gray-700">
                          <strong>{item.label}:</strong> {item.value}
                        </p>
                      ))}
                    </div>
                  )}
                  
                  {section.content && (
                    <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                      {section.content}
                    </p>
                  )}
                </section>
              );
            })}

            <div className="mt-8 p-6 bg-primary/5 rounded-xl border-l-4 border-primary">
              <div className="flex items-start space-x-3">
                <AlertCircle className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                <p className="text-gray-700 font-medium">{t.contactNote}</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Legal;
